import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { cn } from "cn";

/**
 * Подпись раздела: мелкая приглушённая капитель над группой полей или
 * блоком. По умолчанию `span`; заголовку тег задаётся через `as`, чтобы
 * разметка осталась смысловой, а нативный `Label` подставляется через `render`.
 */
function SectionLabel({
  as = "span",
  className,
  render,
  ...props
}: useRender.ComponentProps<"span"> & { as?: "span" | "h2" | "h3" | "h4" }) {
  return useRender({
    defaultTagName: as,
    props: mergeProps<"span">(
      { className: cn("text-[11px] tracking-wider text-muted-foreground uppercase", className) },
      props,
    ),
    render,
    state: { slot: "section-label" },
  });
}

export { SectionLabel };
